export var APPEARANCE = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  HERO: "hero",
  TERTIARY: "tertiary"
};